// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as CalculatorRouteImport } from './routes/calculator'
import { Route as CancellationRouteImport } from './routes/cancellation'
import { Route as CategoriesRouteImport } from './routes/categories'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as ComingSoonRouteImport } from './routes/coming-soon'
import { Route as ConfirmEmailRouteImport } from './routes/confirm-email'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as DiscoverRouteImport } from './routes/discover'
import { Route as FavoritesRouteImport } from './routes/favorites'
import { Route as HelpRouteImport } from './routes/help'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MaintenanceRouteImport } from './routes/maintenance'
import { Route as MerchantRouteImport } from './routes/merchant'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as PartnerRouteImport } from './routes/partner'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SubscriptionsRouteImport } from './routes/subscriptions'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminApprovalsRouteImport } from './routes/admin.approvals'
import { Route as AdminBookingsRouteImport } from './routes/admin.bookings'
import { Route as AdminCmsRouteImport } from './routes/admin.cms'
import { Route as AdminEarningsRouteImport } from './routes/admin.earnings'
import { Route as AdminPayoutsRouteImport } from './routes/admin.payouts'
import { Route as AdminPlansRouteImport } from './routes/admin.plans'
import { Route as AdminPoliciesRouteImport } from './routes/admin.policies'
import { Route as AdminProductsRouteImport } from './routes/admin.products'
import { Route as AdminReportsRouteImport } from './routes/admin.reports'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminSpacesRouteImport } from './routes/admin.spaces'
import { Route as CompaniesCompanyIdRouteImport } from './routes/companies.$companyId'
import { Route as MerchantIndexRouteImport } from './routes/merchant.index'
import { Route as MerchantAnalyticsRouteImport } from './routes/merchant.analytics'
import { Route as MerchantBookingsRouteImport } from './routes/merchant.bookings'
import { Route as MerchantClientPlansRouteImport } from './routes/merchant.client-plans'
import { Route as MerchantFastActionRouteImport } from './routes/merchant.fast-action'
import { Route as MerchantPayoutsRouteImport } from './routes/merchant.payouts'
import { Route as MerchantProductsRouteImport } from './routes/merchant.products'
import { Route as MerchantRevenueRouteImport } from './routes/merchant.revenue'
import { Route as MerchantSettingsRouteImport } from './routes/merchant.settings'
import { Route as MerchantSpacesRouteImport } from './routes/merchant.spaces'
import { Route as MerchantSubscriptionRouteImport } from './routes/merchant.subscription'
import { Route as SpacesSpaceIdRouteImport } from './routes/spaces.$spaceId'
import { Route as AdminApprovalsIndexRouteImport } from './routes/admin.approvals.index'
import { Route as AdminApprovalsIdRouteImport } from './routes/admin.approvals.$id'
import { Route as AdminPlansIndexRouteImport } from './routes/admin.plans.index'
import { Route as AdminPlansIdRouteImport } from './routes/admin.plans.$id'
import { Route as AdminPlansNewRouteImport } from './routes/admin.plans.new'
import { Route as AdminProductsIndexRouteImport } from './routes/admin.products.index'
import { Route as AdminProductsIdRouteImport } from './routes/admin.products.$id'
import { Route as AdminSpacesIndexRouteImport } from './routes/admin.spaces.index'
import { Route as AdminSpacesIdRouteImport } from './routes/admin.spaces.$id'
import { Route as MerchantSpacesIndexRouteImport } from './routes/merchant.spaces.index'
import { Route as MerchantSpacesNewRouteImport } from './routes/merchant.spaces.new'
import { Route as AdminPlansIdEditRouteImport } from './routes/admin.plans.$id.edit'
import { Route as AdminPlansIdSubscribersRouteImport } from './routes/admin.plans.$id.subscribers'
import { Route as MerchantSpacesIdEditRouteImport } from './routes/merchant.spaces.$id.edit'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const CalculatorRoute = CalculatorRouteImport.update({
            id: '/calculator',path: '/calculator',getParentRoute: () => rootRouteImport
          })
const CancellationRoute = CancellationRouteImport.update({
            id: '/cancellation',path: '/cancellation',getParentRoute: () => rootRouteImport
          })
const CategoriesRoute = CategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => rootRouteImport
          })
const CheckoutRoute = CheckoutRouteImport.update({
            id: '/checkout',path: '/checkout',getParentRoute: () => rootRouteImport
          })
const ComingSoonRoute = ComingSoonRouteImport.update({
            id: '/coming-soon',path: '/coming-soon',getParentRoute: () => rootRouteImport
          })
const ConfirmEmailRoute = ConfirmEmailRouteImport.update({
            id: '/confirm-email',path: '/confirm-email',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const DiscoverRoute = DiscoverRouteImport.update({
            id: '/discover',path: '/discover',getParentRoute: () => rootRouteImport
          })
const FavoritesRoute = FavoritesRouteImport.update({
            id: '/favorites',path: '/favorites',getParentRoute: () => rootRouteImport
          })
const HelpRoute = HelpRouteImport.update({
            id: '/help',path: '/help',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MaintenanceRoute = MaintenanceRouteImport.update({
            id: '/maintenance',path: '/maintenance',getParentRoute: () => rootRouteImport
          })
const MerchantRoute = MerchantRouteImport.update({
            id: '/merchant',path: '/merchant',getParentRoute: () => rootRouteImport
          })
const NotFoundRoute = NotFoundRouteImport.update({
            id: '/not-found',path: '/not-found',getParentRoute: () => rootRouteImport
          })
const PartnerRoute = PartnerRouteImport.update({
            id: '/partner',path: '/partner',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RegisterRoute = RegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SubscriptionsRoute = SubscriptionsRouteImport.update({
            id: '/subscriptions',path: '/subscriptions',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminApprovalsRoute = AdminApprovalsRouteImport.update({
            id: '/approvals',path: '/approvals',getParentRoute: () => AdminRoute
          })
const AdminBookingsRoute = AdminBookingsRouteImport.update({
            id: '/bookings',path: '/bookings',getParentRoute: () => AdminRoute
          })
const AdminCmsRoute = AdminCmsRouteImport.update({
            id: '/cms',path: '/cms',getParentRoute: () => AdminRoute
          })
const AdminEarningsRoute = AdminEarningsRouteImport.update({
            id: '/earnings',path: '/earnings',getParentRoute: () => AdminRoute
          })
const AdminPayoutsRoute = AdminPayoutsRouteImport.update({
            id: '/payouts',path: '/payouts',getParentRoute: () => AdminRoute
          })
const AdminPlansRoute = AdminPlansRouteImport.update({
            id: '/plans',path: '/plans',getParentRoute: () => AdminRoute
          })
const AdminPoliciesRoute = AdminPoliciesRouteImport.update({
            id: '/policies',path: '/policies',getParentRoute: () => AdminRoute
          })
const AdminProductsRoute = AdminProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => AdminRoute
          })
const AdminReportsRoute = AdminReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => AdminRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRoute
          })
const AdminSpacesRoute = AdminSpacesRouteImport.update({
            id: '/spaces',path: '/spaces',getParentRoute: () => AdminRoute
          })
const CompaniesCompanyIdRoute = CompaniesCompanyIdRouteImport.update({
            id: '/companies/$companyId',path: '/companies/$companyId',getParentRoute: () => rootRouteImport
          })
const MerchantIndexRoute = MerchantIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MerchantRoute
          })
const MerchantAnalyticsRoute = MerchantAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => MerchantRoute
          })
const MerchantBookingsRoute = MerchantBookingsRouteImport.update({
            id: '/bookings',path: '/bookings',getParentRoute: () => MerchantRoute
          })
const MerchantClientPlansRoute = MerchantClientPlansRouteImport.update({
            id: '/client-plans',path: '/client-plans',getParentRoute: () => MerchantRoute
          })
const MerchantFastActionRoute = MerchantFastActionRouteImport.update({
            id: '/fast-action',path: '/fast-action',getParentRoute: () => MerchantRoute
          })
const MerchantPayoutsRoute = MerchantPayoutsRouteImport.update({
            id: '/payouts',path: '/payouts',getParentRoute: () => MerchantRoute
          })
const MerchantProductsRoute = MerchantProductsRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => MerchantRoute
          })
const MerchantRevenueRoute = MerchantRevenueRouteImport.update({
            id: '/revenue',path: '/revenue',getParentRoute: () => MerchantRoute
          })
const MerchantSettingsRoute = MerchantSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => MerchantRoute
          })
const MerchantSpacesRoute = MerchantSpacesRouteImport.update({
            id: '/spaces',path: '/spaces',getParentRoute: () => MerchantRoute
          })
const MerchantSubscriptionRoute = MerchantSubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => MerchantRoute
          })
const SpacesSpaceIdRoute = SpacesSpaceIdRouteImport.update({
            id: '/spaces/$spaceId',path: '/spaces/$spaceId',getParentRoute: () => rootRouteImport
          })
const AdminApprovalsIndexRoute = AdminApprovalsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminApprovalsRoute
          })
const AdminApprovalsIdRoute = AdminApprovalsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminApprovalsRoute
          })
const AdminPlansIndexRoute = AdminPlansIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminPlansRoute
          })
const AdminPlansIdRoute = AdminPlansIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminPlansRoute
          })
const AdminPlansNewRoute = AdminPlansNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminPlansRoute
          })
const AdminProductsIndexRoute = AdminProductsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminProductsRoute
          })
const AdminProductsIdRoute = AdminProductsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminProductsRoute
          })
const AdminSpacesIndexRoute = AdminSpacesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminSpacesRoute
          })
const AdminSpacesIdRoute = AdminSpacesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminSpacesRoute
          })
const MerchantSpacesIndexRoute = MerchantSpacesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MerchantSpacesRoute
          })
const MerchantSpacesNewRoute = MerchantSpacesNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => MerchantSpacesRoute
          })
const AdminPlansIdEditRoute = AdminPlansIdEditRouteImport.update({
            id: '/edit',path: '/edit',getParentRoute: () => AdminPlansIdRoute
          })
const AdminPlansIdSubscribersRoute = AdminPlansIdSubscribersRouteImport.update({
            id: '/subscribers',path: '/subscribers',getParentRoute: () => AdminPlansIdRoute
          })
const MerchantSpacesIdEditRoute = MerchantSpacesIdEditRouteImport.update({
            id: '/$id/edit',path: '/$id/edit',getParentRoute: () => MerchantSpacesRoute
          })





const AdminApprovalsRouteChildren = {
  AdminApprovalsIdRoute: AdminApprovalsIdRoute,AdminApprovalsIndexRoute: AdminApprovalsIndexRoute
}

const AdminApprovalsRouteWithChildren = AdminApprovalsRoute._addFileChildren(AdminApprovalsRouteChildren)




const AdminPlansIdRouteChildren = {
  AdminPlansIdEditRoute: AdminPlansIdEditRoute,AdminPlansIdSubscribersRoute: AdminPlansIdSubscribersRoute
}

const AdminPlansIdRouteWithChildren = AdminPlansIdRoute._addFileChildren(AdminPlansIdRouteChildren)



const AdminPlansRouteChildren = {
  AdminPlansIdRoute: AdminPlansIdRouteWithChildren,AdminPlansNewRoute: AdminPlansNewRoute,AdminPlansIndexRoute: AdminPlansIndexRoute
}

const AdminPlansRouteWithChildren = AdminPlansRoute._addFileChildren(AdminPlansRouteChildren)




const AdminProductsRouteChildren = {
  AdminProductsIdRoute: AdminProductsIdRoute,AdminProductsIndexRoute: AdminProductsIndexRoute
}

const AdminProductsRouteWithChildren = AdminProductsRoute._addFileChildren(AdminProductsRouteChildren)




const AdminSpacesRouteChildren = {
  AdminSpacesIdRoute: AdminSpacesIdRoute,AdminSpacesIndexRoute: AdminSpacesIndexRoute
}

const AdminSpacesRouteWithChildren = AdminSpacesRoute._addFileChildren(AdminSpacesRouteChildren)



const AdminRouteChildren = {
  AdminApprovalsRoute: AdminApprovalsRouteWithChildren,AdminBookingsRoute: AdminBookingsRoute,AdminCmsRoute: AdminCmsRoute,AdminEarningsRoute: AdminEarningsRoute,AdminPayoutsRoute: AdminPayoutsRoute,AdminPlansRoute: AdminPlansRouteWithChildren,AdminPoliciesRoute: AdminPoliciesRoute,AdminProductsRoute: AdminProductsRouteWithChildren,AdminReportsRoute: AdminReportsRoute,AdminSettingsRoute: AdminSettingsRoute,AdminSpacesRoute: AdminSpacesRouteWithChildren,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const MerchantSpacesRouteChildren = {
  MerchantSpacesNewRoute: MerchantSpacesNewRoute,MerchantSpacesIndexRoute: MerchantSpacesIndexRoute,MerchantSpacesIdEditRoute: MerchantSpacesIdEditRoute
}

const MerchantSpacesRouteWithChildren = MerchantSpacesRoute._addFileChildren(MerchantSpacesRouteChildren)



const MerchantRouteChildren = {
  MerchantAnalyticsRoute: MerchantAnalyticsRoute,MerchantBookingsRoute: MerchantBookingsRoute,MerchantClientPlansRoute: MerchantClientPlansRoute,MerchantFastActionRoute: MerchantFastActionRoute,MerchantPayoutsRoute: MerchantPayoutsRoute,MerchantProductsRoute: MerchantProductsRoute,MerchantRevenueRoute: MerchantRevenueRoute,MerchantSettingsRoute: MerchantSettingsRoute,MerchantSpacesRoute: MerchantSpacesRouteWithChildren,MerchantSubscriptionRoute: MerchantSubscriptionRoute,MerchantIndexRoute: MerchantIndexRoute
}

const MerchantRouteWithChildren = MerchantRoute._addFileChildren(MerchantRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRouteWithChildren,CalculatorRoute: CalculatorRoute,CancellationRoute: CancellationRoute,CategoriesRoute: CategoriesRoute,CheckoutRoute: CheckoutRoute,ComingSoonRoute: ComingSoonRoute,ConfirmEmailRoute: ConfirmEmailRoute,ContactRoute: ContactRoute,DashboardRoute: DashboardRoute,DiscoverRoute: DiscoverRoute,FavoritesRoute: FavoritesRoute,HelpRoute: HelpRoute,LoginRoute: LoginRoute,MaintenanceRoute: MaintenanceRoute,MerchantRoute: MerchantRouteWithChildren,NotFoundRoute: NotFoundRoute,PartnerRoute: PartnerRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,RegisterRoute: RegisterRoute,ResetPasswordRoute: ResetPasswordRoute,SubscriptionsRoute: SubscriptionsRoute,TermsRoute: TermsRoute,CompaniesCompanyIdRoute: CompaniesCompanyIdRoute,SpacesSpaceIdRoute: SpacesSpaceIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)